import { jsonFetch } from "@/lib/helpers";
import { Product } from "@/models";
import { GET_PRODUCTS_URL } from "./api-url.constants";
import { GetProductsResponseDTO } from "./dtos";
import { mapProductsDTOToProducts } from "./mappers";

export const getProducts = async (): Promise<Product[]> => {
  const response = await jsonFetch<GetProductsResponseDTO>(GET_PRODUCTS_URL);
  return mapProductsDTOToProducts(response.data);
};
